"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _utils = require("../utils");

var _TextField = _interopRequireDefault(require("../TextField"));

var _Row = _interopRequireDefault(require("../Layout/Row"));

var renderSingleSelected = function renderSingleSelected(RenderValue, value, overflowEllipsis) {
  if ((0, _isNil["default"])(RenderValue)) {
    return /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
      overflowEllipsis: overflowEllipsis
    }, value);
  }

  if ((0, _isString["default"])(RenderValue)) {
    return /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
      overflowEllipsis: overflowEllipsis
    }, value[RenderValue]);
  }

  return /*#__PURE__*/_react["default"].createElement(RenderValue, (0, _extends2["default"])({}, value || {}, {
    "data-qa": "render-single-selected"
  }));
};

var renderMultipleSelected = function renderMultipleSelected(renderValue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var single = arguments.length > 2 ? arguments[2] : undefined;
  var plural = arguments.length > 3 ? arguments[3] : undefined;
  var optionsSize = options.length;
  if (optionsSize < 1) return '';
  var firstItemLabel = renderSingleSelected(renderValue, options[0], true);
  var moreCount = optionsSize - 1;
  var moreText = moreCount === 1 ? single : plural;
  return /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    spacing: 1,
    align: "center",
    "data-qa": "render-multiple-selected"
  }, firstItemLabel, moreCount > 0 && /*#__PURE__*/_react["default"].createElement(_TextField["default"], null, "+ ", moreCount, " ", moreText));
};

var DropdownInputSelectedValue = function DropdownInputSelectedValue(_ref) {
  var variant = _ref.variant,
      renderValue = _ref.renderValue,
      value = _ref.value,
      _ref$single = _ref.single,
      single = _ref$single === void 0 ? '' : _ref$single,
      _ref$plural = _ref.plural,
      plural = _ref$plural === void 0 ? '' : _ref$plural;

  if ((0, _utils.isEmpty)(value)) {
    return null;
  }

  var isSingleSelect = variant === 'single';
  return isSingleSelect ? renderSingleSelected(renderValue, value, isSingleSelect) : renderMultipleSelected(renderValue, value, single, plural);
};

var _default = /*#__PURE__*/_react["default"].memo(DropdownInputSelectedValue);

exports["default"] = _default;